import {useReversalService} from '../../service/reversal/index'

const useSaveAddaForm = () => {
    const {saveFormTableChages} = useReversalService()
  const updateFormTable = async (data: any) => {
     await saveFormTableChages(data)
  };
  return {
    updateFormTable,
  };
};

export default useSaveAddaForm;
